import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { isModeBup } from '@BUP/services/BraveUp'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'

const ModeBupRoute = ({ children }) => {
  const organization = useContext(OrganizationContext)

  if (!isModeBup(organization)) return <Navigate to='/' />
  return children
}

export default ModeBupRoute
